import script from "./AtomSelectFlag.vue?vue&type=script&lang=ts&setup=true"
export * from "./AtomSelectFlag.vue?vue&type=script&lang=ts&setup=true"

import "./AtomSelectFlag.vue?vue&type=style&index=0&id=57425296&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57425296"]])

export default __exports__